var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _circle3, _path9, _circle4, _path10, _circle5, _path11, _path12, _circle6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderEmptyIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h200v200H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.068 36.904c0-2.709 2.184-4.904 4.878-4.904h72.474c2.694 0 4.878 2.195 4.878 4.904 0 2.708-2.184 4.903-4.878 4.903h-15.331c-2.694 0-4.878 2.195-4.878 4.904 0 2.708 2.184 4.903 4.878 4.903h35.54c3.464 0 6.272 2.823 6.272 6.305 0 3.482-2.808 6.304-6.272 6.304H40.221c-3.464 0-6.271-2.822-6.271-6.304s2.807-6.305 6.271-6.305h29.965a4.846 4.846 0 0 1-1.742-.322 4.905 4.905 0 0 0 3.136-4.581 4.905 4.905 0 0 0-3.136-4.582 4.844 4.844 0 0 1 1.742-.322h-13.24c-2.694 0-4.878-2.195-4.878-4.903ZM158.688 57.919c0-3.482 2.808-6.305 6.272-6.305h12.543c3.464 0 6.272 2.823 6.272 6.305 0 3.482-2.808 6.304-6.272 6.304H164.96c-3.464 0-6.272-2.822-6.272-6.304ZM40.221 74.03c-3.464 0-6.271 2.823-6.271 6.305 0 3.482 2.807 6.305 6.271 6.305h85.715c3.463 0 6.271-2.823 6.271-6.305 0-3.482-2.808-6.304-6.271-6.304H40.221ZM7.469 101.701c0-2.902 2.34-5.254 5.226-5.254h42.509c2.886 0 5.226 2.352 5.226 5.254 0 2.901-2.34 5.253-5.226 5.253h-2.09c-2.887 0-5.227 2.353-5.227 5.254 0 2.902 2.34 5.254 5.226 5.254h33.45c-2.887 0-5.227-2.352-5.227-5.254 0-2.901 2.34-5.254 5.227-5.254h78.745c2.887 0 5.227 2.353 5.227 5.254 0 2.902-2.34 5.254-5.227 5.254h-14.285c-2.887 0-5.227 2.352-5.227 5.254 0 2.901 2.34 5.254 5.227 5.254h8.014c2.886 0 5.226 2.352 5.226 5.253 0 2.902-2.34 5.254-5.226 5.254h-32.056c2.886 0 5.226 2.352 5.226 5.254 0 2.902-2.34 5.254-5.226 5.254H85.866c-2.887 0-5.227 2.352-5.227 5.254 0 2.901 2.34 5.253 5.227 5.253h6.272c2.886 0 5.226 2.353 5.226 5.254 0 2.902-2.34 5.254-5.226 5.254H48.932c-2.887 0-5.226-2.352-5.226-5.254 0-2.901 2.34-5.254 5.226-5.254h.697c2.886 0 5.226-2.352 5.226-5.253 0-2.902-2.34-5.254-5.226-5.254H5.726c-2.886 0-5.226-2.352-5.226-5.254 0-2.902 2.34-5.254 5.226-5.254h20.906c-2.886 0-5.226-2.352-5.226-5.254 0-2.901 2.34-5.253 5.226-5.253h1.046c2.886 0 5.226-2.353 5.226-5.254 0-2.902-2.34-5.254-5.226-5.254h-2.44c-2.886 0-5.226-2.352-5.226-5.254 0-2.901 2.34-5.254 5.227-5.254H12.695c-2.886 0-5.226-2.352-5.226-5.253ZM182.033 106.954c-2.886 0-5.226 2.353-5.226 5.254 0 2.902 2.34 5.254 5.226 5.254h13.241c2.886 0 5.226-2.352 5.226-5.254 0-2.901-2.34-5.254-5.226-5.254h-13.241Z",
    fill: "#F6F8FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.845 151.086c-2.309 0-4.181 1.882-4.181 4.203 0 2.321 1.872 4.203 4.181 4.203h9.059c2.309 0 4.181-1.882 4.181-4.203 0-2.321-1.872-4.203-4.181-4.203h-9.059Z",
    fill: "#F6F8FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.221,
    cy: 86.721,
    fill: "#EEF2F5",
    r: 2.721
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.479,
    cy: 145.925,
    fill: "#EEF2F5",
    r: 2.721
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.658 137.842a.842.842 0 0 1 1.684 0v5.053a.842.842 0 0 1-1.684 0v-5.053ZM186.658 147.105a.842.842 0 0 1 1.684 0v5.053a.842.842 0 0 1-1.684 0v-5.053ZM194.658 144.158a.842.842 0 0 1 0 1.684h-5.053a.842.842 0 0 1 0-1.684h5.053ZM185.395 144.158a.842.842 0 0 1 0 1.684h-5.053a.842.842 0 0 1 0-1.684h5.053ZM52.626 161.215a1.075 1.075 0 0 1 1.52 1.519l-4.558 4.557a1.075 1.075 0 0 1-1.519-1.519l4.557-4.557ZM44.272 169.569a1.075 1.075 0 0 1 1.519 1.519l-4.557 4.557a1.073 1.073 0 1 1-1.519-1.519l4.557-4.557ZM54.145 174.126a1.074 1.074 0 0 1-1.519 1.519l-4.557-4.557a1.074 1.074 0 0 1 1.52-1.519l4.556 4.557ZM45.791 165.772a1.074 1.074 0 0 1-1.519 1.519l-4.557-4.557a1.074 1.074 0 0 1 1.52-1.519l4.556 4.557ZM41.868 40.868a1.632 1.632 0 0 1 0 3.264h-9.79a1.632 1.632 0 0 1 0-3.264h9.79ZM23.921 40.868a1.632 1.632 0 0 1 0 3.264h-9.79a1.632 1.632 0 0 1 0-3.264h9.79ZM29.632 56.368a1.632 1.632 0 0 1-3.264 0v-9.79a1.632 1.632 0 0 1 3.264 0v9.79ZM29.632 38.421a1.632 1.632 0 0 1-3.264 0v-9.79a1.632 1.632 0 0 1 3.264 0v9.79Z",
    fill: "#D2D9E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 15a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
    fill: "url(#a)",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.643 148.711c-6.011.707-11.458-3.591-12.165-9.602L20.39 87.412c-.708-6.01 3.59-11.457 9.602-12.165l81.626-9.612c6.01-.708 11.457 3.591 12.165 9.602l6.087 51.696c.708 6.011-3.591 11.458-9.601 12.165l-81.626 9.613Z",
    fill: "url(#b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.745 115.156c-6.757-1.123-11.324-7.51-10.2-14.266L71.2 42.781c1.123-6.756 7.51-11.323 14.266-10.2l91.751 15.247c6.756 1.123 11.323 7.51 10.2 14.267l-9.656 58.108c-1.123 6.757-7.511 11.323-14.267 10.201l-91.75-15.248Z",
    fill: "url(#c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.058 52.8a5.167 5.167 0 0 1 5.945-4.25l14.272 2.371a5.167 5.167 0 0 1 4.25 5.945l-2.033 12.233a5.167 5.167 0 0 1-5.944 4.25l-14.273-2.372a5.167 5.167 0 0 1-4.25-5.944L81.058 52.8ZM73.432 92.389a4.134 4.134 0 0 1 4.755-3.4l12.234 2.033a4.134 4.134 0 0 1 3.4 4.755l-.847 5.097a4.134 4.134 0 0 1-4.756 3.401l-12.233-2.033a4.134 4.134 0 0 1-3.4-4.756l.847-5.097ZM98.918 96.624a4.134 4.134 0 0 1 4.756-3.4l12.233 2.033a4.134 4.134 0 0 1 3.4 4.756l-.847 5.097a4.133 4.133 0 0 1-4.755 3.4l-12.234-2.033a4.133 4.133 0 0 1-3.4-4.755l.847-5.098ZM123.385 100.69a4.133 4.133 0 0 1 4.755-3.4l12.234 2.033a4.134 4.134 0 0 1 3.4 4.756l-.847 5.097a4.134 4.134 0 0 1-4.756 3.4l-12.233-2.033a4.133 4.133 0 0 1-3.4-4.755l.847-5.098ZM148.871 104.926a4.134 4.134 0 0 1 4.756-3.4l12.233 2.033a4.133 4.133 0 0 1 3.4 4.755l-.847 5.097a4.133 4.133 0 0 1-4.755 3.4l-12.234-2.033a4.133 4.133 0 0 1-3.4-4.755l.847-5.097Z",
    fill: "#fff",
    fillOpacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 51,
    r: 27,
    fill: "url(#d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m142.58 69.194-.018-4.182a20.292 20.292 0 0 1-5.281-.923 2.528 2.528 0 0 1-1.68-3.042l.039-.163c.364-1.433 1.872-2.278 3.269-1.794 1.422.494 3.05.821 4.773.814 2.502-.008 4.23-.985 4.209-2.745-.011-1.68-1.425-2.724-4.691-3.816-4.723-1.571-7.93-3.76-7.941-8.029-.017-3.866 2.702-6.91 7.41-7.858l-.019-4.182 4.312-.008.042 3.877c1.605.063 2.917.287 4.023.573a2.522 2.522 0 0 1 1.8 3.078c-.361 1.388-1.79 2.223-3.175 1.818a14.005 14.005 0 0 0-3.859-.534c-2.861.007-3.787 1.247-3.769 2.482.002 1.451 1.557 2.376 5.298 3.758 5.247 1.822 7.369 4.242 7.378 8.195.013 3.91-2.747 7.265-7.81 8.169l.021 4.496-4.331.016Z",
    fill: "#EDF0F6",
    fillOpacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.861,
    cy: 157.361,
    r: 17.855,
    transform: "rotate(12.776 144.861 157.361)",
    fill: "url(#e)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M149.143 166.544a1.206 1.206 0 0 1-.996 1.142c-1.072.185-2.598.198-4.194-.194-2.337-.572-4.444-1.935-5.701-4.124-.79-1.361-1.196-3.098-1.1-4.92l-1.375-.333c-.461-.114-.75-.607-.632-1.089l.011-.041c.118-.482.598-.792 1.06-.678l1.134.278c.057-.412.093-.677.147-.898.091-.372.237-.803.422-1.27l-1.163-.282c-.462-.114-.751-.607-.633-1.089.119-.483.598-.792 1.06-.679l1.413.345c.796-1.606 1.944-2.932 3.268-3.78 2.259-1.453 4.915-1.739 7.346-1.149 1.424.352 2.434.866 3.197 1.384.532.357.678 1.089.336 1.656l-.015.022c-.357.589-1.089.771-1.639.418-.633-.412-1.444-.786-2.501-1.043-1.558-.381-3.235-.232-4.78.719-.884.576-1.692 1.43-2.143 2.535l7.958 1.928c.462.113.751.606.633 1.088-.119.483-.598.792-1.06.679l-8.314-2.016c-.134.391-.265.799-.329 1.061-.08.331-.161.663-.229 1.115l8.332 2.012c.479.11.771.621.646 1.115-.115.5-.612.814-1.084.693l-7.969-1.935c-.012 1.137.26 2.168.745 2.992.96 1.592 2.254 2.467 4.012 2.892a9.621 9.621 0 0 0 2.93.229c.678-.075 1.248.503 1.207 1.217Z",
    fill: "#EEF2F5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.154,
    cy: 112.808,
    r: 16.35,
    transform: "rotate(-13.21 31.154 112.808)",
    fill: "url(#f)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.969 106.989c-.498-.55-.48-1.407.039-1.913.518-.507 1.342-.472 1.839.078l4.741 5.244 1.913-6.806c.2-.713.922-1.111 1.612-.888.69.223 1.087.982.886 1.696l-1.733 6.167 1.458-.342c.698-.164 1.402.295 1.573 1.024.172.729-.255 1.453-.953 1.617l-2.526.593.31 1.321 2.526-.593c.698-.164 1.402.295 1.573 1.024.172.73-.255 1.454-.953 1.618l-2.526.593.93 3.962c.171.729-.256 1.453-.953 1.617-.698.164-1.402-.295-1.574-1.024l-.93-3.962-2.526.593c-.698.163-1.402-.295-1.573-1.025-.172-.729.255-1.453.953-1.617l2.526-.593-.31-1.321-2.526.593c-.698.164-1.402-.295-1.573-1.024-.172-.729.255-1.453.953-1.617l1.12-.263-4.296-4.752Z",
    fill: "#D2D9E7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.5 30.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z",
    fill: "url(#g)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 164.5,
    r: 9.5,
    fill: "url(#h)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 61.5,
    y1: 11.539,
    x2: 69.577,
    y2: 18.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 23.433,
    y1: 113.261,
    x2: 126.826,
    y2: 101.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 66.372,
    y1: 71.835,
    x2: 182.589,
    y2: 91.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 144.5,
    y1: 24,
    x2: 144.5,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0ADC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 144.861,
    y1: 139.506,
    x2: 144.861,
    y2: 175.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EABC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 31.154,
    y1: 96.458,
    x2: 31.154,
    y2: 129.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AA7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 176.5,
    y1: 26,
    x2: 187,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 92,
    y1: 155,
    x2: 92,
    y2: 174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE3ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderEmptyIllustration);
export default __webpack_public_path__ + "static/media/order-empty-illustration.2d208a4cfedc7aa7876247352cb6f0b5.svg";
export { ForwardRef as ReactComponent };